module.exports = {
	path: "/document-center/:categories(.*)?",
	component: require("@views/document-center/DocumentCenter").default,

	meta: {
		showButton: true,
		title: "Document Center",
		icon: ["far", "books"],
		primary: true,
		search: {
			placeholder: "Search Documents",
			show: true
		}
	},

	props: route => ({
		slug: parseCategorySlug(route)
	}),

	children: [
		{
			path: "/document-center/:categories(.*)",
			component: require("@views/document-center/Category").default,
			props: route => ({
				slug: parseCategorySlug(route)
			})
		}
	]
};

function parseCategorySlug(route) {
	let { categories = [] } = route.params;

	if (typeof categories === "string") {
		return categories
			.replace(/\/edit\/?$/, "")
			.split("/")
			.filter(s => s)
			.join("_");
	}
}
